import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Select,
  Selection,
  SelectItem,
  SelectSection,
  Slider,
} from '@nextui-org/react';
import { useEnumByName } from '../../../hooks/queries/common';

export interface ModelSettings {
  name: string;
  temperature: number;
  max_tokens: number;
  top_p?: number;
  frequency_penalty?: number;
  presence_penalty?: number;
}

interface ModalSettingsProps {
  isOpen: boolean;
  onClose: () => void;
  settings: ModelSettings;
  isLoading: boolean;
  onSettingsChange: (settings: ModelSettings) => void;
  handleSave: (settings: ModelSettings) => void;
}

// const DEFAULT_MODELS = [
//   'claude-3-5-sonnet-20241022 (latest)',
//   'gpt-4',
//   'gpt-3.5-turbo',
// ];
// const FINE_TUNE_MODELS: string[] = [];

export default function ModalSettings({
  isOpen,
  onClose,
  settings,
  onSettingsChange,
  handleSave,
  isLoading,
}: ModalSettingsProps) {
  const { data: models } = useEnumByName('agentos:modelenum');

  const updateSetting = (key: keyof ModelSettings, value: number | string) => {
    onSettingsChange({ ...settings, [key]: value });
  };

  const onModelChange = async (keys: Selection) => {
    const selected = Array.from(keys)[0] as string;
    updateSetting('name', selected);
  };

  console.log(settings.name);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" placement="center">
      <ModalContent>
        <ModalHeader>Model Settings</ModalHeader>
        <ModalBody>
          <div className="space-y-4">
            <Select
              label="Model"
              selectedKeys={settings.name ? [settings.name] : []}
              onSelectionChange={onModelChange}
            >
              <SelectSection>
                {models &&
                  Object.keys(models).map((model) => (
                    <SelectItem key={model}>{model}</SelectItem>
                  ))}
              </SelectSection>
              {/* <SelectSection title="Fine Tunes">
                {FINE_TUNE_MODELS.map((model) => (
                  <SelectItem key={model}>{model}</SelectItem>
                ))}
              </SelectSection> */}
            </Select>
            <div className="mt-2 flex w-full flex-col gap-6 px-1">
              {[
                {
                  key: 'temperature',
                  label: 'Temperature',
                  max: 1,
                  step: 0.01,
                },
                {
                  key: 'max_tokens',
                  label: 'Max Tokens',
                  max: 8192,
                  minValue: 1,
                  // step: 1024,
                },
              ].map(({ key, label, max, step }) => (
                <Slider
                  key={key}
                  aria-label={label}
                  label={label}
                  maxValue={max}
                  minValue={0}
                  size="sm"
                  step={step}
                  value={settings[key as keyof ModelSettings] as number}
                  onChange={(value) =>
                    updateSetting(key as keyof ModelSettings, value as number)
                  }
                />
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter className="justify-between border-t mt-4">
          <Button variant="bordered" onPress={onClose}>
            Cancel
          </Button>
          <Button
            color="primary"
            isLoading={isLoading}
            onPress={() => handleSave(settings)}
          >
            Save
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
